import { AccountQuery } from '@awork/_shared/state/account.query'
import { convertToTimezone } from './date-operations'

/**
 * Gets the saved account timezone, including when called outside Angular injection.
 * @returns {string} The account timezone or the account default before hydration.
 */
export function getAccountTimezone(): string {
  const timezone = AccountQuery.instance?.query('timezone')
  return timezone?.() || 'Europe/Berlin'
}

/**
 * Gets calendar fields in the account timezone for date pickers and period calculations.
 * The returned Date represents wall-clock fields, not an instant.
 * @param {Date | string} [date=new Date()] The instant to convert.
 * @returns {Date} Account-local calendar fields.
 */
export function getAccountDate(date: Date | string = new Date()): Date {
  return convertToTimezone(date, getAccountTimezone())
}
